export default "__VITE_ASSET__EnSPUCVG__"